import { render } from "./compliance.cattle.io.clusterscan.vue?vue&type=template&id=fd75f7fa&scoped=true"
import script from "./compliance.cattle.io.clusterscan.vue?vue&type=script&lang=js"
export * from "./compliance.cattle.io.clusterscan.vue?vue&type=script&lang=js"

import "./compliance.cattle.io.clusterscan.vue?vue&type=style&index=0&id=fd75f7fa&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd75f7fa"]])

export default __exports__